<template>
  <div class="about-wrap">
    <div class="wrap-sect text container">
      <div class="main-text" :class=" !readMore && isMobile()? 'rgba':''">
        <h2>Про нас</h2>
        <p>
          Наш невеликий і затишний суші бар розташовано майже в центрі
          смт.Стрижавки! У 2019 році ми розпочали розвиватись та удосконалювати
          себе!
        </p>

        <p>
          <br />
          Наша команда створена для того,щоб ви наслоджувались бомбезною і
          унікальною їжею. Готуємо, творимо, креативимо, розвиваємося,
          експерементуємо, щоб ви отримали якість! Головний пріоритет - висока
          якість їжі та сервісу.
          <span v-if="!isMobile() && readMore"></span>
          <span v-else>...</span>
        </p>
      </div>

      <div class="more-text" v-show="!isMobile() || isMobile() && readMore">
        <p>
          Ми щодня працюємо та вдосконалюємось, шукаючи нові способи потішити
          вас смачними стравами. Обираємо найсвіжіші продукти, приймаємо в
          команду найвідповідальніших людей, готуємо з любов'ю і очікуємо
          зворотній зв'язок … … і він завжди є! 😉 Нам довіряють не перший рік.
          <br />
        </p>
        <p>
          Окрім приємних цін, ми регулярно влаштовуємо акції, щоб вам було ще
          приємніше ласувати смачними стравами. В меню від Avocado Ви знайдете
          як традиційні страви, так і ексклюзивні, створені нашими кухарями, а
          наші кур'єри подбають про своєчасну доставку вашого замовлення.
        </p>
        <p>
         <ul class="list">Наші переваги: <br />
          <li class="list__item">✔️швидка доставка </li>
          <li class="list__item">✔️якість </li>
          <li class="list__item">✔️великий асортимент </li>
          <li class="list__item">✔️доступні ціни </li>
          </ul> 
          <br />
           Ми любимо те, що робимо!<br />
          Ласкаво просимо до Avocado!
        </p>
      </div>
      <div v-if="isMobile()" class="read-more" @click="readMore = !readMore">
        <span v-if="readMore">Згорнути</span>
        <span v-else>Читати ділі</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlockAbout",
  data() {
    return {
      readMore: false,
    };
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
.about-wrap {
  height: 100%;
  background: black;
  padding: 10vh 15px;
  max-width: 1250px;
  margin: auto;
}
.text {
  color: white;
  line-height: 1.38;
  font-size: larger;
  font-family: "Roboto", sans-serif;
}
.main-text {
  position: relative;
}
.rgba:before {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 70%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background-image: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 80%,
    rgba(0, 0, 0, 0.5) 10%,
    rgba(0, 0, 0, 0.8) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#000000',GradientType=0 );
  content: "";
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.read-more {
  text-decoration: underline;
  cursor: pointer;
  font-size: smaller;
  color: lightseagreen;
}
.list{
  display: flex;
  flex-direction: column;
  max-width: 300px;
  margin: auto;
}
.list__item{
  display: flex; 
  align-content: center;
}


@media (max-width: 850px) {
  .about-wrap {
    padding: 2vh 5px;
  }
  .about {
    padding: 5vh 5vh;
  }
  .list{
    padding: 0;
  }
}
</style>
